import EmptyContent from '../components/main/empty-content';
import EventPage from '../components/main/list-view/left-side/event-page/event-page';
import Global from '../global';
import Loadable from 'react-loadable';
import LoaderContent from '../components/main/loader';
import React from 'react';
import TestPageCTA from '../components/main/test-pages/test-page-cta';
import TestPageOddsFormat from '../components/main/test-pages/general-test-page';

// import HomePageLoadable from '../components/main/home-page/home-page';
// import StandaloneHighlightsStripLoadable from '../components/main/standalone-strips/standalone-highlights-strip';

const loading = props => {
  // eslint-disable-next-line react/prop-types
  if (props.error) {
    return <div>{JSON.stringify(props, null, 2)}</div>;
  }

  return <LoaderContent />;
};

const ListViewLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "sc-listview" */ '../components/main/list-view/list-view'
    ),
  loading
});

const HomePageLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "sc-homepage" */ '../components/main/home-page/home-page'
    ),
  loading
});

const StandaloneHighlightsStripLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "standalone-highlights-strip" */ '../components/main/standalone-strips/standalone-highlights-strip'
    ),
  loading
});

export const defaultRoute = {
  path: '',
  components: EmptyContent
};

export default function getRoutes() {
  const atLeastOneLetter = '[^/]{0,}[A-Za-z]{1,}[^/]{0,}';
  const onlyDigits = '\\d+';

  return [
    {
      path: '/test-page-cta',
      component: Global.isProduction ? EmptyContent : TestPageCTA
    },
    {
      path: '/general-test-page',
      component: Global.isProduction ? EmptyContent : TestPageOddsFormat
    },
    {
      path: '/888event',
      component: Global.isProduction ? EmptyContent : EventPage
    },
    {
      path: '/upfor8',
      component: EmptyContent
    },
    {
      path: '/porra8',
      component: EmptyContent
    },
    {
      path: '/8rigtige',
      component: EmptyContent
    },
    {
      path: '/super8',
      component: EmptyContent
    },
    {
      path: '/home',
      component: Global.config.enableSCHomePage
        ? HomePageLoadable
        : EmptyContent
    },
    {
      path: '/settings',
      component: EmptyContent
    },
    {
      path: '/sports/a-z',
      component: EmptyContent
    },
    {
      path: '/event/live/:eventId',
      component: EmptyContent
    },
    {
      path: '/event/:eventId',
      component: EmptyContent
    },
    {
      path: '/filter/888',
      component: EmptyContent
    },
    {
      path: `/filter/:sports(${atLeastOneLetter}|888)/:regions(${atLeastOneLetter})?/:leagues(${atLeastOneLetter})?/:participants(${atLeastOneLetter})?/:attributes(${atLeastOneLetter})?/:eventId(${onlyDigits})`,
      component: EmptyContent
    },
    {
      path: `/filter/:sports(politics)/:regions(${atLeastOneLetter})?/:leagues(${atLeastOneLetter})?/:participants(${atLeastOneLetter})?/:attributes(${atLeastOneLetter})?/`,
      component: Global.isProduction ? EmptyContent : ListViewLoadable
    },
    {
      path: `/filter/:sports(${atLeastOneLetter}|888)/:regions(${atLeastOneLetter})?/:leagues(${atLeastOneLetter})?/:participants(${atLeastOneLetter})?/:attributes(${atLeastOneLetter})?/`,
      component: EmptyContent
    },
    {
      path: `/drill-down/:sports(${atLeastOneLetter}|888)?/:regions(${atLeastOneLetter})?/:leagues(${atLeastOneLetter})?/:participants(${atLeastOneLetter})?/:attributes(${atLeastOneLetter})?/:eventId(${onlyDigits})?`,
      component: EmptyContent
    },
    {
      path: '/bethistory/:date/:couponType?',
      component: EmptyContent
    },
    {
      path: '/bethistory/detail/:couponId',
      component: EmptyContent
    },
    {
      path: '/racing/:racingType',
      component: EmptyContent
    },
    {
      path: '/standalone-strip/highlights',
      component: StandaloneHighlightsStripLoadable
    }
  ];
}
